import { z } from 'zod/mini'

export const ChrofyClassificationPageState = z.object({
  records: z.record(
    z.string(),
    z.array(
      z.object({
        key: z.string(),
        classificationKey: z.string(),
        code: z.string(),
        value: z.string(),
        displayOrder: z.number()
      })
    )
  ),
  types: z.array(
    z.object({
      code: z.string(),
      label: z.string(),
      displayOrder: z.number(),
      memo: z.string(),
      itemCount: z.optional(z.number())
    })
  ),
  selectedType: z.string(),
  serverErrors: z.array(z.string())
})
/** @typedef {import('zod/mini').infer<ChrofyClassificationPageState>} _ChrofyClassificationPageState */
